export const environment = {
  production: false,
  baseUrl: '/main/dispatcher',
  localStorageID: 'dispatcher',

  clientId: '52b8k275dnrg2ergocc2dcshq8',
  logoutUrl: 'https://emed-dispatcher.emed-cloud.it/main/dispatcher/logout',
  authority: 'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_ngf8A2TUO/.well-known/openid-configuration'
};
